import * as d3 from "d3";
/**
 * 氨基酸棒棒糖
 * @author zhaoming
 */
const utils = {
    circleTransformYAry: [],
    leftX: 0,
    delayContentHeight: 0,
    maxWidthScale: 0,
    /**
     * 模型支架
     * @param {*} width 
     * @returns 
     */
    rectangleRackTemp(width = 860) {
        let that = this;
        let temp = [
            {
                append: "line",
                x1: 0,
                x2: width,
                y1: 0,
                y2: 0,
                stroke: "#000000",
                transform: "",
            },
            {
                append: "line",
                x1: 0,
                x2: width,
                y1: 37,
                y2: 37,
                stroke: "#000000",
                transform: "",
            },
            {
                append: "line",
                x1: width,
                x2: width,
                y1: 0,
                y2: 37,
                stroke: "#000000",
                transform: "",
            },
            {
                append: "line",
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 37,
                stroke: "#000000",
                transform: "",
            },
        ];
        return temp;
    },
    /**
     * 密码子域
     * @param {密码子coding} param 
     * @returns 
     */
    rectangleRectData(param) {
        let res = [];
        let color = d3.schemeYlOrRd[9];
        let rectX = [];
        param.forEach((item, index) => {
            if (index == 0) {
                res.push(this.rectComponent({ x: 0, width: item.proportion, height: 37, fill: "#fff", fillOpacity: "0", nodeData: item }));
                rectX.push(item.proportion);
            } else {
                let temp = rectX[index - 1] + item.proportion;
                rectX.push(temp);
                res.push(this.rectComponent({ x: rectX[index - 1], width: item.proportion, height: 37, fill: "#fff", fillOpacity: "0", nodeData: item }));
            }
        })
        return res;
    },
    /**
     * 密码子虚线位置
     * @param {密码子参数} param 
     * @returns 
     */
    rectangleLineData(param) {
        let res = [];
        let rectX = [];
        param.forEach((item, index) => {
            if (index == 0) {
                rectX.push(item.proportion);
            } else {
                let temp = rectX[index - 1] + item.proportion;
                rectX.push(temp);
                res.push(this.lineComponent({
                    x1: rectX[index - 1],
                    x2: rectX[index - 1],
                    y1: 0,
                    y2: 37,
                    stroke: "#000000",
                    strokeDasharray: "4,2",
                    strokeOpacity: 1
                }));
            }
        });
        return res;
    },
    /**
     * 氨基酸蛋白质域
     * @param {氨基酸蛋白质域} param 
     * @returns 
     */
    rectanglePdomainsRectData(param) {
        let res = [];
        let color = d3.schemeYlOrRd[9];
        if (param) {
            param.forEach((item, index) => {
                let r = this.rectComponent({ x: item.startX, width: item.stopW, height: 37, fill: item.color, fillOpacity: '1', className: 'uid_' + item.cdd, nodeData: item });
                // let g =this.gComponent({
                //     transform: "translate(0, 0)",
                //     children: [r],
                // })
                res.push(r);
            })
        }
        return res;
    },
    codonSeqData(param, contentWidth, fontSize = 10) {
        let res = {}, children1 = [], children2 = [], len = param.codingSiteStr.length, codonLen = param.transCodonData.length, startCdsFrame = param.startCdsFrame * 1;
        let wid = len * fontSize;
        let widCodon = codonLen * fontSize;
        let visible = 'none';
        let checkIn = true;
        let offsetXCodon = (contentWidth - widCodon) / codonLen;
        let offsetX = (contentWidth - wid) / len;
        this.maxWidthScale = wid;
        let groupCourierAry = this.codonSeqGroupCourier(param, len, fontSize, offsetX);
        if (contentWidth >= widCodon && contentWidth < wid) {
            visible = 'block';
            children2 = this.transCodonTextData(param, groupCourierAry, codonLen, fontSize, offsetXCodon, checkIn);
        } else if (contentWidth >= wid) {
            visible = 'block';
            checkIn = false;
            children1 = this.codonSeqTextData(param.codingSiteStr, groupCourierAry, len, fontSize);
            children2 = this.transCodonTextData(param, groupCourierAry, codonLen, fontSize, offsetXCodon, checkIn);
        } else {
            visible = 'none';
            checkIn = true;
        }

        res = this.gComponent({
            className: "g-codon",
            transform: "translate(-5, 13)",
            style: { 'display': visible },
            nodeData: { visible: visible, strWidth: wid, offsetX: offsetX, checkIn: checkIn },
            children: [
                this.gComponent({
                    className: "g-codon-1",
                    transform: "translate(0, 0)",
                    children: children1,
                }),
                this.gComponent({
                    className: "g-codon-2",
                    transform: "translate(0, 0)",
                    children: children2,
                }),
            ],
        });

        return res;
    },
    /**
     * 氨基酸text component
     * @param {*} param 
     * @param {*} groupCourierAry 
     * @param {*} len 
     * @param {*} fontSize 
     * @param {*} offsetX 
     * @param {*} checkIn 
     * @returns 
     */
    transCodonTextData(param, groupCourierAry, len, fontSize, offsetX, checkIn) {
        let res = [], leftX = 0, codingSiteStrLen = param.codingSiteStr.length, index = 0;
        let transCodonData = param.transCodonData;
        for (let i = 0; i < codingSiteStrLen; i++) {
            let halfway = groupCourierAry[i].rectWidth / 2;
            if (groupCourierAry[i].flag == 'odd' || groupCourierAry[i].flag == 'even') {
                leftX = groupCourierAry[i].rectX + halfway;
                let text = this.textComponent({
                    fill: "black",
                    fontFamily: "Courier",
                    fontWeight: "",
                    fontSize: "" + fontSize + "px",
                    x: checkIn == false ? leftX : leftX,
                    y: 10,
                    text: transCodonData[index]
                });
                index += 1;
                res.push(text);
            }

        }
        // for (let i = 0; i < len; i++) {
        //     if (offsetX > 0) {
        //         leftX += fontSize + offsetX;
        //     } else {
        //         leftX += fontSize;
        //     }
        //     let text = this.textComponent({
        //         fill: "black",
        //         fontFamily: "Courier",
        //         fontWeight: "",
        //         fontSize: "" + 10 + "px",
        //         x: checkIn == false ? leftX - fontSize : leftX,
        //         y: 10,
        //         text: transCodonData[i]
        //     });
        //     res.push(text);
        // }
        return res;
    },
    /**
     * 密码子数据=计算组运送
     * @param {*} param 
     * @param {*} len 
     * @param {*} fontSize 
     * @param {*} offsetX 
     * @returns 
     */
    codonSeqGroupCourier(param, len, fontSize, offsetX) {
        let res = [], leftX = 0, flag = 0, rectX = 5, rectWidth = 0;
        let cdsFrameOffsetX = 0, cdsFrame = param.startCdsFrame * 1;
        if (cdsFrame != 0) {
            cdsFrameOffsetX = (fontSize + offsetX) * cdsFrame;
            rectX += cdsFrameOffsetX;
        }
        for (let i = 0; i < len; i++) {
            let j = i + 1, json = {};
            if (offsetX > 0) {
                leftX += fontSize + offsetX;
            } else {
                leftX += fontSize;
            }
            if (j % 3 == 0) {
                flag += 1;
                if (rectWidth == 0) {
                    rectWidth = leftX;
                }
                json = { leftX: leftX, rectX: rectX, rectWidth: rectWidth, flag: flag % 2 == 0 ? 'even' : 'odd' };
                rectX = leftX + fontSize / 2 + cdsFrameOffsetX;
            } else {
                json = { leftX: leftX, rectX: cdsFrameOffsetX, rectWidth: 0, flag: 0 };
            }
            res.push(json);
        }
        return res;
    },
    /**
     * 密码子数据=text component
     * @param {*} param 
     * @param {*} groupCourierAry 
     * @param {*} len 
     * @param {*} fontSize 
     * @returns 
     */
    codonSeqTextData(param, groupCourierAry, len, fontSize) {
        let res = [], leftX = 0, rectX = 0;
        groupCourierAry.forEach((item, index) => {
            let text = this.textComponent({
                fill: "black",
                fontFamily: "Courier",
                fontWeight: "",
                fontSize: "" + fontSize + "px",
                x: item.leftX,
                text: param[index]
            });
            if (item.flag == 'odd') {
                let rect = this.rectComponent({ x: item.rectX, y: -12, width: item.rectWidth, height: 22, fill: "black", fillOpacity: "0.1" });
                res.push(text, rect);
            } else {
                res.push(text);
            }

        });
        return res;
    },
    /**
     * 数据渲染游标
     * @param {游标数据} param 
     * @returns 
     */
    minorTickData(param) {
        let res = {}, mtmp = [];
        param.forEach(item => {
            mtmp.push(
                this.gComponent({
                    append: "g",
                    className: "",
                    transform: "translate(" + item.xMinor + ", 0)",
                    children: [
                        this.textComponent({
                            fill: "black",
                            fontFamily: "Arial",
                            fontWeight: "",
                            fontSize: "12px",
                            x: '-' + item.minor.toString().length * 0.5 * 7.5, // minor tostring length * 50% to minor length * 7.5 px
                            text: item.minor
                        })
                    ]
                })
            );
        });
        res = this.gComponent({
            className: "g-tick",
            transform: "translate(0, 50)",
            children: mtmp
        })
        return res;
    },
    //#### sans begin ####//
    transitionContentHeight(domId, dHeight) {
        let $this = this;
        let delayCHeight = $this.delayContentHeight;
        if (delayCHeight > 50) {
            let contentHeight = d3.select("#" + domId + "").style('height');
            let height = dHeight + delayCHeight;
            d3.select("#" + domId + "").transition().duration(2000).attr('height', height);
        } else {
            d3.select("#" + domId + "").transition().duration(2000).attr('height', dHeight);
        }
    },
    transitionMiddleMarginTop(y) {
        let $this = this;
        let delayCHeight = $this.delayContentHeight;
        let middleY = 0;
        if (delayCHeight > 50) {
            middleY = y + delayCHeight - 50;
        } else {
            middleY = y;
        }
        return middleY;
    },
    lollipopSans({ param, direction = 'up', callback = {} }) {
        let $this = this;
        let transformY1 = direction == 'down' ? 5 : 50;
        let children = [], enterTX = 0, enterTY = 0;
        $this.circleTransformYAry.length = 0;
        if (param) {
            children = this.lollipopSansChildren(param.allMap, direction, callback);
        } else {
            children = [];
        }
        if (direction == 'down') {
            enterTY = 0;
            enterTX = this.leftX;
        } else {
            $this.delayContentHeight = $this.sansTransform(transformY1);
            enterTY = $this.delayContentHeight;
            enterTX = this.leftX;
        }
        let resObject = $this.gComponent({
            className: `g-lollipop-sans`,
            transform: {
                enter: `translate(${enterTX},${enterTY})`,
                exit: `translate(${enterTX},${transformY1})`,
            },
            duration: 2000,
            delay: 4000,
            children: children
        })
        return resObject;
    },
    sansTransform(tfy) {
        let $this = this;
        let max = d3.max($this.circleTransformYAry);
        let y = 0;
        if (max > 50) {
            y = tfy + max;
        } else {
            y = tfy;
        }
        return y;
    },
    yesRadiusScale(param) {
        const yesRadiusScale = d3.scaleSqrt()
            .domain([d3.min(param, (d) => {
                return d.count;
            }), d3.max(param, (d) => {
                return d.count;
            })])
            .range([6, 20])
            .nice();
        return yesRadiusScale;
    },
    upwardYesScale(param, contentHeight) {
        let $this = this;
        let yesScale = d3.scaleLinear()
            .domain([d3.min(param, (d) => {
                return d.count;
            }), d3.max(param, (d) => {
                return d.count;
            })])
            .range([contentHeight, 10])
            .nice();
        return yesScale;
    },
    downwardYesScale(param, contentHeight) {
        let $this = this;
        let yesScale = d3.scaleLinear()
            .domain([d3.min(param, (d) => {
                return d.count;
            }), d3.max(param, (d) => {
                return d.count;
            })])
            .range([15, contentHeight])
            .nice();
        return yesScale;
    },
    /**
     * upward 向上 && downward 向下
     * @param {*} param 
     * @param {*} direction 
     * @param {*} callback 
     * @returns 
     */
    lollipopSansChildren(param, direction, callback) {
        let $this = this;
        let results = [], gHeight = 255, yesScale = null, lineY1 = 0;
        if (direction == 'down') {
            gHeight = 155;
            lineY1 = 0;
            yesScale = $this.downwardYesScale(param, gHeight);
        } else {
            gHeight = 255;
            lineY1 = gHeight;
            yesScale = $this.upwardYesScale(param, gHeight);
        }
        const yesRadiusScale = $this.yesRadiusScale(param);
        param.forEach((item, i) => {
            let group = item.group[0];
            let scale = yesScale(item.count);
            if (direction != "down" && scale >= 242) {
                scale = 242;
            }
            let line = [$this.lineComponent({
                x1: 0,
                x2: 0,
                y1: lineY1,
                y2: scale,
                stroke: group.color,
                strokeDasharray: "0",
                strokeOpacity: 1
            })];
            let circle = $this.lollipopSansCircle(item.group, direction, scale, yesRadiusScale, callback);
            let g = $this.gComponent({
                className: `g-lp-pop g-lp-${group.consequence}`,
                transform: {
                    enter: `translate(${group.posX || 0},0)`,
                    exit: `translate(0,0)`,
                },
                duration: 600,
                delay: Math.random() * 500,
                children: [...line, ...circle]
            })
            results.push(g);
        })
        return results;
    },
    lollipopSansCircle(param, direction, scale, radiusScale, callback) {
        let $this = this;
        let results = [];
        let sof = [];
        let transformY = 0;
        param.forEach((item, i) => {
            let circle = {};
            let radiusR = radiusScale(item.number)
            sof.push(radiusR);
            if (i != 0) {
                if (direction == 'down') {
                    transformY += sof[i - 1] * 2;
                } else {
                    transformY -= sof[i - 1] * 2;
                }
                $this.circleTransformYAry.push(Math.abs(transformY));
            }
            if (item.key) {
                circle = $this.lollipopSansCircleFusion(item, scale, radiusR, direction, callback);
            } else {
                circle = $this.lollipopSansCircleSnp(item, scale, radiusR, direction, callback);
            }
            results.push(
                $this.gComponent({
                    className: `g-lp-pop g-lp-pop-circle`,
                    transform: {
                        enter: `translate(0,${transformY})`,
                        exit: `translate(0,0)`,
                    },
                    duration: 1000,
                    delay: Math.random() * 50000,
                    children: [...circle],
                    nodeData: item,
                    onClick: (event, datum) => {
                        callback(datum);
                    },
                    onMouseOver: (event, datum) => {
                        let tmp = null;
                        d3.select(event.target).transition()
                            .duration(100)
                            .attr('fill-opacity', '0.8');
                        if (datum.nodeData.key) {
                            tmp = $this.fusionDiscTipHtml(datum.nodeData);
                        } else {
                            tmp = $this.snpDiscTipHtml(datum.nodeData);
                        }
                        $this.discTipMouseOver(event, tmp);

                    },
                    onMouseOut: (event, datum) => {
                        d3.select(event.target).transition()
                            .duration(100)
                            .attr('fill-opacity', '1');
                        $this.discTipMouseOut();
                    },
                }));
        });
        return results;
    },
    lollipopSansCircleSnp(param, scale, radiusR, direction, callback) {
        let $this = this;
        let results = [];
        let cy = 0;
        if (direction == 'down') {
            cy = scale + radiusR;
        } else {
            cy = scale - radiusR;
        }
        let circle = $this.circleComponent({
            fill: param.color,
            stroke: 'white',
            strokeWidth: '1',
            r: radiusR,
            cx: 0,
            cy: cy,
            nodeData: param,
            onClick: (event, datum) => {
                callback(datum);
            },
        });
        results.push(circle);
        return results;
    },
    lollipopSansCircleFusion(param, scale, radiusR, direction, callback) {
        let $this = this;
        let results = [], a = {}, b = {};
        let cx = radiusR * 0.25;
        let cy = 0;
        let hasGeneAry = this.lollipopSansFusionHasGeneAry(param);
        if (direction == 'down') {
            cy = scale + radiusR;
        } else {
            cy = scale - radiusR;
        }

        if (radiusR <= 10) {
            cx = 2.5;
        }
        a = {
            fill: '#C9C9C9',
            r: radiusR,
            cy: cy,
            cx: cx,
        };
        b = {
            fill: hasGeneAry ? '#000000' : '#646464',
            stroke: '#ffffff',
            strokeWidth: "1",
            r: radiusR,
            cy: cy,
            nodeData: param,
            // onClick: (event, datum) => {
            //     callback(datum);
            // },
        };
        if (param.key == "b") {
            a.r = radiusR;
            a.cy = cy;
            a.cx = -cx;
        }
        results.push($this.circleComponent(a));
        results.push($this.circleComponent(b));
        if (hasGeneAry) {
            results.push($this.textComponent({
                text: '···',
                colour: '#ffffff',
                y: cy + (radiusR / 2),
                fontWeight: 'initial',
                style: { letterSpacing: '0.5px', cursor: 'default' }
            }));
        }
        return results;
    },
    lollipopSansFusionHasGeneAry(param) {
        let mark = false, geneAry = {};
        if (param.key == 'b') {
            geneAry = param.a;
        } else {
            geneAry = param.b;
        }
        if (geneAry.geneAry) {
            mark = true;
        } else {
            mark = false;
        }
        return mark;
    },

    //#### sans end ####//

    /**
     * 计算disc的大小
     * @param {*} number 
     * @returns 
     */
    discDiameter(number = 1) {
        let diameter = 7;
        if (number != 1) {
            diameter += number;
        }
        return diameter;
    },
    /**
     * snp disc down
     * @param {*} param 
     * @param {*} pathY 
     * @returns 
     */
    lollipopSnpDiscDown(param, pathY, callback) {
        let res = [], $this = this;
        let size = param.length;
        param.forEach((item, index) => {
            let y1 = pathY == 0 ? -89 : -pathY + -9;
            let y = y1;
            if (index != 0) {
                y = y1 + $this.discDiameter(param[index - 1].number) * 2;
            }
            let disc = $this.gComponent({
                className: "g-lp-pop-disc",
                transform: 'translate(0, ' + y + ')',
                nodeData: param,
                onMouseOver: (event, datum) => {
                    d3.select(event.target).transition()
                        .duration(100)
                        .attr('fill-opacity', '0.8');
                    if (size == 1) {
                        let tmp = $this.snpDiscTipHtml(datum.nodeData);
                        $this.discTipMouseOver(event, tmp);
                    }

                },
                onMouseOut: (event, datum) => {
                    d3.select(event.target).transition()
                        .duration(100)
                        .attr('fill-opacity', '1');
                    $this.discTipMouseOut();
                },
                children: [
                    $this.circleComponent({
                        fill: item.color,
                        stroke: 'white',
                        strokeWidth: '1',
                        r: $this.discDiameter(item.number),
                        cy: '5',
                        nodeData: item,
                        onClick: (event, datum) => {
                            callback(datum)
                        },
                    }),
                    $this.textComponent({
                        x: '7',
                        y: size == 1 ? '4' : '8',
                        text: item.aminoAcids + " ×" + item.number,
                        fontWeight: 'none',
                        textAnchor: 'none',
                        fillOpacity: size == 1 ? "0" : "1",
                        style: {
                            transform: size == 1 ? "rotate(-90deg)" : "rotate(-25deg)",
                            pointerEvents: "none",
                        }
                    }),
                ]
            });
            res.push(disc);
        });
        return res;
    },
    /**
     * snp disc 
     * @param {*} param 
     * @param {*} pathY 
     * @returns 
     */
    lollipopSnpDisc(param, pathY, callback) {
        let res = [], $this = this;
        let size = param.length;
        param.forEach((item, index) => {
            let y1 = pathY == 0 ? 9 : pathY;
            let y = y1;
            if (index != 0) {
                y = y1 + $this.discDiameter(param[index - 1].number) * 2;
            }
            let disc = $this.gComponent({
                className: "g-lp-pop-disc",
                transform: 'translate(0, -' + y + ')',
                nodeData: param,
                onMouseOver: (event, datum) => {
                    d3.select(event.target).transition()
                        .duration(100)
                        .attr('fill-opacity', '0.8');
                    if (size == 1) {
                        let tmp = $this.snpDiscTipHtml(datum.nodeData);
                        $this.discTipMouseOver(event, tmp);
                    }

                },
                onMouseOut: (event, datum) => {
                    d3.select(event.target).transition()
                        .duration(100)
                        .attr('fill-opacity', '1');
                    $this.discTipMouseOut();
                },
                children: [
                    $this.circleComponent({
                        fill: item.color,
                        stroke: 'white',
                        strokeWidth: '1',
                        r: $this.discDiameter(item.number),
                        cy: '5',
                        nodeData: item,
                        onClick: (event, datum) => {
                            callback(datum);
                        },
                    }),
                    $this.textComponent({
                        x: '7',
                        y: size == 1 ? '4' : '8',
                        text: item.aminoAcids + " ×" + item.number,
                        fontWeight: 'none',
                        textAnchor: 'none',
                        fillOpacity: size == 1 ? "0" : "1",
                        style: {
                            transform: size == 1 ? "rotate(-90deg)" : "rotate(-25deg)",
                            pointerEvents: "none",
                        }
                    }),
                ]
            });
            res.push(disc);
        });
        return res;
    },
    /**
     * disc 鼠标悬停事件 浮窗显示
     * @param {*} event 
     * @param {*} tmp 
     */
    discTipMouseOver(event, tmp) {
        d3.select('.genomics-move-disc-tip>.genomice-move-disc-content').html(tmp);
        if (d3.select('.genomics-move-disc-tip').style('display') != 'block') {
            d3.select('.genomics-move-disc-tip').attr("style", "display:block;opacity:1;");
            let w = d3.select('.genomics-move-disc-tip').style('width');
            let h = d3.select('.genomics-move-disc-tip').style('height');
            d3.select('.genomics-move-disc-tip').attr(
                "style",
                "left:" +
                (event.pageX - parseInt(w) / 2) +
                "px;top:" +
                (event.pageY - parseInt(h) - 20) +
                "px;display:block;opacity:1;"
            );

        }
    },
    /**
     * disc 鼠标离开事件 浮窗消失
     */
    discTipMouseOut() {
        if (d3.select('.genomics-move-disc-tip').style('display') == 'block') {
            d3.select('.genomics-move-disc-tip').attr("style", "display:none;opacity:0;");
        }
    },
    /**
     * snp disc 浮窗提示
     * @param {*} data 
     * @returns 
     */
    snpDiscTipHtml(data) {
        let tmp = [];
        if (data instanceof Array) {
            data.forEach(item => {
                tmp.push('<div><span>' + item.aminoAcids + '(' + item.number + ')</span></div>');
            });
        } else {
            tmp.push('<div><span>' + data.aminoAcids + '(' + data.number + ')</span></div>');
        }
        return tmp.join(' ');
    },
    /**
     * fusion disc 浮窗提示
     * @param {*} data 
     * @returns 
     */
    fusionDiscTipHtml(data) {
        let tmp = [];
        if (data instanceof Array) {
            data.forEach(item => {
                if (item.key == 'b') {
                    if (this.hasOwnGeneAry(item.a)) {
                        tmp = this.fusionDiscTipPartHtml(item.a.geneAry, item.number);
                    } else {
                        tmp = this.fusionDiscTipPartHtml(item.a.gene, item.number);
                    }

                } else {
                    if (this.hasOwnGeneAry(item.b)) {
                        tmp = this.fusionDiscTipPartHtml(item.b.geneAry, item.number);
                    } else {
                        tmp = this.fusionDiscTipPartHtml(item.b.gene, item.number);
                    }
                }
            });
        } else {
            if (data.key == 'b') {
                if (this.hasOwnGeneAry(data.a)) {
                    tmp = this.fusionDiscTipPartHtml(data.a.geneAry, data.number);
                } else {
                    tmp = this.fusionDiscTipPartHtml(data.a.gene, data.number);
                }
            } else {
                if (this.hasOwnGeneAry(data.b)) {
                    tmp = this.fusionDiscTipPartHtml(data.b.geneAry, data.number);
                } else {
                    tmp = this.fusionDiscTipPartHtml(data.b.gene, data.number);
                }
            }
        }
        return tmp.join(' ');
    },
    hasOwnGeneAry(param) {
        let tmp = false;
        if (param.geneAry) {
            tmp = true;
        } else {
            tmp = false;
        }
        return tmp;

    },
    fusionDiscTipPartHtml(param, number) {
        let tmp = [];
        if (param instanceof Array) {
            if (param.length > 15) {
                let arr3 = [];
                for (let i = 0; i < param.length; i += 5) {
                    arr3.push(param.slice(i, i + 5));
                }
                tmp.push('<div><span class="genomice-disc-counts">COUNT[' + number * param.length + ']:</span></div>');
                arr3.forEach(igene => {
                    tmp.push('<div>');
                    igene.forEach(sub => {
                        tmp.push('<span>' + sub + '(' + number + ');</span>');
                    });
                    tmp.push('</div>');
                });
            } else {
                tmp.push('<div><span class="genomice-disc-counts">COUNT[' + number * param.length + ']</span></div>');
                param.forEach(igene => {
                    tmp.push('<div><span>' + igene + '(' + number + ')</span></div>');
                });
            }

        } else {
            tmp.push('<div><span>' + param + '(' + number + ')</span></div>');
        }
        return tmp;
    },
    /**
     * fusion disc down
     * @param {*} param 
     * @param {*} pathY 
     * @returns 
     */
    lollipopFusionDiscDown(param, pathY, callback) {
        let res = [], $this = this;
        let size = param.length;
        param.forEach((item, index) => {
            let y1 = pathY == 0 ? -89 : -pathY + -1;
            let y = y1;
            if (index != 0) {
                y = y1 + $this.discDiameter(param[index - 1].number) * 2;
            }
            let textVal = item.b.gene, a = {
                fill: '#C9C9C9',
                r: $this.discDiameter(item.number) - 1,
                cy: 0,
                cx: '5',
            },
                b = {
                    fill: '#646464',
                    stroke: '#ffffff',
                    strokeWidth: "2",
                    r: $this.discDiameter(item.number),
                    cy: 0,
                    nodeData: item,
                    onClick: (event, datum) => {
                        callback(datum);
                    },
                };
            if (item.key == "b") {
                a.r = $this.discDiameter(item.number) - 1;
                a.cy = 0;
                a.cx = -5;
                textVal = item.a.gene;
            }
            let disc = $this.gComponent({
                className: "g-lp-pop-disc",
                transform: 'translate(0, ' + y + ')',
                nodeData: param,
                onMouseOver: (event, datum) => {
                    if (size == 1) {
                        let tmp = $this.fusionDiscTipHtml(datum.nodeData);
                        $this.discTipMouseOver(event, tmp);
                    }
                },
                onMouseOut: (event, datum) => {
                    $this.discTipMouseOut();
                },
                children: [
                    $this.circleComponent(a),
                    $this.circleComponent(b),
                    $this.textComponent({
                        x: '14',
                        y: size == 1 ? '1' : '2',
                        text: textVal + " ×" + item.number,
                        fontWeight: 'none',
                        textAnchor: 'none',
                        fillOpacity: size == 1 ? "0" : "1",
                        style: {
                            transform: size == 1 ? "rotate(25deg)" : "rotate(25deg)",
                            pointerEvents: "none",
                        }
                    }),
                ]
            });
            res.push(disc);
        })
        return res;
    },
    /**
     * fusion disc 
     * @param {*} param 
     * @param {*} pathY 
     * @returns 
     */
    lollipopFusionDisc(param, pathY, yesRadiusScale, callback) {
        let res = [], $this = this;
        let size = param.length;

        param.forEach((item, index) => {
            let y1 = pathY == 0 ? 9 : pathY + 1;
            let y = y1;
            let rd = yesRadiusScale(item.number);
            if (index != 0) {
                y = y1 + $this.discDiameter(param[index - 1].number) * 2;
            } else {
                y = y1 + item.number - 1;
            }
            let textVal = item.b.gene,
                a = {
                    fill: '#C9C9C9',
                    r: rd,
                    cy: 0,
                    cx: 4,
                },
                b = {
                    fill: '#646464',
                    stroke: '#ffffff',
                    strokeWidth: "1",
                    r: rd,
                    cy: 0,
                    nodeData: item,
                    onClick: (event, datum) => {
                        callback(datum);
                    },
                };
            if (item.key == "b") {
                a.r = rd;
                a.cy = 0;
                a.cx = -4;
                textVal = item.a.gene;
            }
            let disc = $this.gComponent({
                className: "g-lp-pop-disc",
                transform: 'translate(0, -' + y + ')',
                nodeData: param,
                onMouseOver: (event, datum) => {
                    if (size == 1) {
                        let tmp = $this.fusionDiscTipHtml(datum.nodeData);
                        $this.discTipMouseOver(event, tmp);
                    }
                },
                onMouseOut: (event, datum) => {
                    $this.discTipMouseOut();
                },
                children: [
                    $this.circleComponent(a),
                    $this.circleComponent(b),
                    $this.textComponent({
                        x: 13 + item.number / 2,
                        y: size == 1 ? '1' : '2',
                        text: textVal + " ×" + item.number,
                        fontWeight: 'none',
                        textAnchor: 'none',
                        fillOpacity: size == 1 ? "0" : "1",
                        style: {
                            transform: size == 1 ? "rotate(-25deg)" : "rotate(-25deg)",
                            pointerEvents: "none",
                        }
                    }),
                ]
            });
            res.push(disc);
        })

        return res;
    },
    /**
     * rect Component
     * @param {object} param0 
     * @returns 
     */
    rectComponent({ x, y, width, height, fill, fillOpacity = "1", className = "script-rect", nodeData, mouseMove = {} }) {
        return {
            append: "rect",
            class: className,
            x,
            y,
            width,
            height,
            fill,
            fillOpacity: fillOpacity,
            onMouseMove: mouseMove,
            nodeData,
        }
    },
    /**
     * line Component
     * @param {object} param0 
     * @returns 
     */
    lineComponent({ x1, x2, y1, y2, stroke, duration, strokeDasharray, strokeOpacity, className }) {
        return {
            append: "line",
            x1,
            x2,
            y1,
            y2,
            stroke,
            duration,
            strokeDasharray,
            strokeOpacity,
            className,
        }
    },
    /**
     * text Component
     * @param {object} param0 
     * @returns 
     */
    textComponent({
        key,
        text,
        className = "g-lp-pop-mtext",
        x = 0,
        y = 0,
        fontWeight = "bold",
        fontSize = "10px",
        textAnchor = "middle",
        fillOpacity = 1,
        colour,
        r,
        duration = 1000,
        style = { pointerEvents: "none" },
    }) {
        return {
            append: "text",
            key,
            text,
            class: className,
            x,
            y,
            textAnchor,
            fontFamily: "sans-serif",
            fontWeight,
            fontSize,
            fillOpacity: { enter: fillOpacity, exit: 0 },
            fill: colour,
            duration,
            style: style,
        };
    },
    /**
     * circle Component
     * @param {object} param0 
     * @returns 
     */
    circleComponent({
        className = "g-lp-circle",
        fill,
        r,
        cy,
        cx,
        strokeWidth,
        stroke = "none",
        fillOpacity = '1',
        onMouseOver = {},
        onMouseOut = {},
        onClick = {},
        nodeData = {},
    }) {
        return {
            append: "circle",
            class: className,
            fill,
            stroke: stroke,
            fillOpacity: fillOpacity,
            r,
            cy,
            cx,
            strokeWidth,
            transform: "scale(1)",
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            onClick: onClick,
            nodeData: nodeData,
        };
    },
    /**
     * path Component
     * @param {object} param0 
     * @returns 
     */
    pathComponent({ className = "g-lp-path", fill = "none", stroke, d }) {
        return {
            append: "path",
            class: className,
            fill: fill,
            stroke,
            d
        };
    },
    /**
     * g Component
     * @param {object} param0 
     * @returns 
     */
    gComponent({
        className = "node",
        name,
        id,
        value,
        r,
        x,
        y,
        fill,
        colour,
        duration = 1000,
        style = {},
        onMouseOver = {},
        onMouseOut = {},
        onClick = {},
        children = [],
        transform,
        nodeData,
    }) {
        return {
            append: "g",
            class: className,
            transform,
            duration,
            style: style,
            delay: Math.random() * 300,
            children: children,
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            onClick: onClick,
            nodeData,
        };
    }


};

export default utils;